import React from "react";
import { Link, useLocation } from "react-router-dom";
import imgFrame427321791 from "../assets/images/801c36195628ec9551d571118f7e538a22e2ed29.png";

export default function LegalHeader() {
  const location = useLocation();

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Terms & Conditions", path: "/terms-and-conditions" },
    { label: "Refund Policy", path: "/refund-policy" },
    { label: "Service Policy", path: "/service-policy" },
    { label: "Disclaimer", path: "/disclaimer" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-200">
      <div className="max-w-[1280px] mx-auto px-6 h-18 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <div className="w-[140px] h-[45px] relative overflow-hidden">
            <img
              alt="Fixezy Logo"
              className="absolute h-[428.45%] left-[-24.57%] max-w-none top-[-159%] w-[147.98%]"
              src={imgFrame427321791}
            />
          </div>
        </Link>

        {/* Center Legal Tabs */}
        <nav className="hidden md:flex items-center gap-5">
          {navLinks.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors ${
                  isActive
                    ? "text-black border-b-2 border-black pb-1 font-semibold"
                    : "text-gray-500 hover:text-black pb-1"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Right Link */}
        <div className="flex items-center">
          <Link
            to="/"
            className="text-sm font-medium text-gray-600 hover:text-black transition-colors"
          >
            Back to Home →
          </Link>
        </div>
      </div>

      {/* Mobile Legal Tabs bar */}
      <div className="md:hidden flex items-center overflow-x-auto px-6 py-2 gap-4 bg-gray-50 border-t border-gray-200">
        {navLinks.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`shrink-0 text-xs font-medium whitespace-nowrap transition-colors ${
                isActive ? "text-black font-semibold" : "text-gray-500 hover:text-black"
              }`}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </header>
  );
}
